module.exports = __webpack_public_path__ + "img/north-korea.526d9fce.svg";